/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import EnhancedTable from "components/common_components/Tables/EnhancedTable";
import Button from "components/common_components/Button";
import Page from "components/common_components/Page/Page";
import useStyles from "./useStyles";
import { useDispatch } from "react-redux";
import { notifyError, notifyInfo } from "redux/actions/Notifications";
import LoadingPage from "components/common_components/LoadingPage";
import CustomersContext from "./CustomersContext";
import Header from "components/common_components/Header";
import Icon from "components/common_components/Icon";
import Status from "components/common_components/Status";
import { ConfirmDialog } from "components/common_components/Dialogs";

const headCells = [
    { index: 1, id: "firstName", disablePadding: false, label: "First Name" },
    { index: 2, id: "lastName", disablePadding: false, label: "Last Name" },
    { index: 3, id: "ssn", disablePadding: false, label: "SSN" },
    { index: 4, id: "homePhone", disablePadding: true, label: "Home Phone" },
    { index: 5, id: "email", disablePadding: true, label: "Email" },
    { index: 6, id: "birthDateString", orderBy: "birthDate", disablePadding: true, label: "Date of Birth" },
    {
        index: 7,
        id: "enabled",
        disablePadding: true,
        label: "Status",
        type: "bool",
        render: (_, { value, data }) => {
            return <Status id={value ? "active" : "inactive"} withIcon />;
        },
    },
];

function List({ history }) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const [pageableData, setPageableData] = useState(undefined);
    const defaultRequestData = {
        filter: {},
        orderBy: "firstName",
        orderDirection: "asc",
        pageNumber: 0,
        pageSize: 5,
    };

    const { Customers } = useContext(CustomersContext);
    // const [isInvitingAll, setIsInvitingAll] = useState(false);
    const [confirmDialogProps, setConfirmDialogProps] = useState({
        open: false,
        title: "",
        content: "",
        primaryButtonText: "",
        onPrimaryClick: undefined,
        secondaryButtonText: "Cancel",
        onSecondaryClick: () => setConfirmDialogProps((prev) => ({ ...prev, open: false })),
        onClose: () => setConfirmDialogProps((prev) => ({ ...prev, open: false })),
    });

    function getCustomers(requestData = defaultRequestData, showLoader = true) {
        if (showLoader) {
            setIsLoading(true);
        }
        Customers.getList({
            onSuccess: (data, pageableData) => {
                setData(data);
                setPageableData(pageableData);
                setIsLoading(false);
            },
            onInfo: (info, pageableData) => {
                dispatch(notifyInfo(info));
                setPageableData(pageableData);
                setIsLoading(false);
            },
            onError: (error) => {
                dispatch(notifyError(error));
                setIsLoading(false);
            },
            data: requestData,
        });
    }

    useEffect(() => {
        getCustomers();

        return () => {
            setData([]);
        };
    }, []);

    function onRowClickHandler(item) {
        history.push(`/customers/${item.id}`);
    }

    function onDeleteSuccess() {
        dispatch(notifyInfo("Removed successfully!"));
        getCustomers();
    }

    function onDeleteError(error) {
        dispatch(notifyError(error.message));
    }

    function onDeleteHandler(selectedItems) {
        Customers.deleteAll({
            ids: selectedItems,
            onSuccess: onDeleteSuccess,
            onError: onDeleteError,
        });
    }

    // function handleInviteAll() {
    //     setConfirmDialogProps((prev) => ({
    //         ...prev,
    //         open: true,
    //         title: "Invite all clients",
    //         content: "Are you sure you want to send a portal invitation to all clients?",
    //         primaryButtonText: "Yes, send invitations",
    //         onPrimaryClick: async () => {
    //             setConfirmDialogProps((p) => ({ ...p, open: false }));
    //             setIsInvitingAll(true);
    //             try {
    //                 await Customers.inviteAll();
    //                 dispatch(notifySuccess("Invitations sent successfully!"));
    //             } catch (error) {
    //                 const message = error?.response?.data?.message || error?.response?.data || "Error sending invitations";
    //                 dispatch(notifyError(message));
    //             } finally {
    //                 setIsInvitingAll(false);
    //             }
    //         },
    //     }));
    // }

    function filterBuilder(filterValue) {
        return filterValue
            ? {
                  firstName: filterValue,
                  lastName: filterValue,
                  ssn: filterValue,
                  email: filterValue,
                  homePhone: filterValue,
              }
            : {};
    }

    return (
        <Page className={classes.root}>
            {isLoading ? (
                <LoadingPage />
            ) : (
                <>
                    <Header title="Clients">
                        <Button primary onClick={() => history.push("/customers/add")}>
                            <Icon name="add" size="md" color="white" />
                            <span>Add</span>
                        </Button>
                    </Header>
                    {/* <Button secondary outline small onClick={handleInviteAll} loading={isInvitingAll}>
                        <Icon name="paper-plane" size="md" color="secondary" />
                        <span>Invite all to the portal</span>
                    </Button> */}
                    <div className="layout">
                        <EnhancedTable
                            headCells={headCells}
                            data={data}
                            dense={false}
                            defaultOrder={{ order: "asc", orderBy: "firstName" }}
                            keyColumnName="id"
                            selectable
                            onRowClick={onRowClickHandler}
                            onDelete={onDeleteHandler}
                            onRequestData={getCustomers}
                            filterBuilder={filterBuilder}
                            pageableData={pageableData}
                        />
                    </div>
                </>
            )}
            <ConfirmDialog {...confirmDialogProps} />
        </Page>
    );
}

List.propTypes = {
    history: PropTypes.shape({
        replace: PropTypes.func,
        location: PropTypes.shape({
            pathname: PropTypes.string,
        }),
    }).isRequired,
};

export default withRouter(List);
